import request from '@/utils/request'

// 图片、文件上传
export function uploadAdmin(data) {
  return request({
    url: '/upload/uploadAdmin',
    method: 'post',
    data
  })
}

// 单个简历上传
export function personAppenAddFile(data) {
  return request({
    url: '/personAppen/addFile',
    method: 'post',
    data
  })
}

// 列表简历上传
export function wordUpload(data) {
  return request({
    url: '/wordUpload/wordUpload',
    method: 'post',
    data
  })
}

//codeType查询表
export function codeType(data) {
  return request({
    url: '/code/getCodeByStatus',
    method: 'get',
    params: data
  })
}
//获取城市
export function getCityAll(data) {
  return request({
    url: '/city/getCityAll',
    method: 'get',
    params: data
  })
}

//简历读取（personCode有则修改简历，无则新增简历）
export function ResumeParser(data) {
  return request({
    url: '/resume/ResumeParser',
    method: 'post',
    data
  })
}


//根据id删除人才
export function deletePersonBypercode(data) {
  return request({
    url: '/person/deletePersonBypercode',
    method: 'get',
    params: data
  })
}
